const faqs = [
  {
    q: '黄瓜影院的影视资源是否需要付费？',
    a: '黄瓜影院所有影视资源均为免费在线观看，无需任何会员费用。我们持续收录全网高清电视剧全集和电影大全，用户只需打开网站即可畅享高清画质流畅播放体验。',
  },
  {
    q: '播放时出现卡顿或缓冲怎么办？',
    a: '黄瓜影院采用先进的视频加速技术，确保高清画质下也能流畅播放。如遇卡顿，建议检查您的网络连接或尝试切换清晰度。我们也在持续优化服务器以提供更稳定的观影体验。',
  },
  {
    q: '平台上的剧集更新速度如何？',
    a: '黄瓜影院与各大内容源保持同步更新，热门电视剧通常在播出后数小时内即可在平台观看。每日更新数量可观，确保您不错过任何精彩剧集。',
  },
  {
    q: '如何快速找到我想看的影片？',
    a: '您可以使用首页顶部的搜索功能，或通过分类导航浏览不同类别的影视内容。黄瓜影院的智能推荐系统会根据您的观影记录，为您精准推荐可能感兴趣的影片。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full border border-accent-500/20 mb-3">
            常见问答
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 tracking-wide">
            您可能想了解的问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 mt-2">
            关于黄瓜影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-500/10 mt-0.5">
                    <span className="text-sm font-bold text-primary-400">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2">{faq.q}</h3>
                    <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}